form.<template>
    <b-container class="py-5">
        <b-card
            bg-variant="light"
            class="mb-4"
            >
            <p class="fw-900">ページ（Homeの上下）</p>

            <b-form-group
                >
                <strong>ヘッダーテキスト</strong>
                <quill-editor
                    v-model="form.page.header"
                    :options="quillEdiorOptions"
                    class="bg-white"
                    />

                <strong>ヘッダー表示切替テキスト（※空欄の場合表示切替なし）</strong>
                <b-form-input
                    v-model="form.page.headerCollapse"
                    />
            </b-form-group>
    
            <b-form-group
                >
                <strong>フッターテキスト</strong>
                <quill-editor
                    v-model="form.page.footer"
                    :options="quillEdiorOptions"
                    class="bg-white"
                    />

                <strong>フッター表示切替テキスト（※空欄の場合表示切替なし）</strong>
                <b-form-input
                    v-model="form.page.footerCollapse"
                    />
            </b-form-group>
        </b-card>

        <b-card
            bg-variant="light"
            class="mb-4"
            >
            <p class="fw-900">ダイアログ（通読内容の上下）</p>

            <b-form-group
                >
                <strong>ヘッダーテキスト</strong>
                <quill-editor
                    v-model="form.modal.header"
                    :options="quillEdiorOptions"
                    class="bg-white"
                    />

                <strong>ヘッダー表示切替テキスト（※空欄の場合表示切替なし）</strong>
                <b-form-input
                    v-model="form.modal.headerCollapse"
                    />
            </b-form-group>
    
            <b-form-group
                >
                <strong>フッターテキスト</strong>
                <quill-editor
                    v-model="form.modal.footer"
                    :options="quillEdiorOptions"
                    class="bg-white"
                    />

                <strong>フッター表示切替テキスト（※空欄の場合表示切替なし）</strong>
                <b-form-input
                    v-model="form.modal.footerCollapse"
                    />
            </b-form-group>
        </b-card>
    
        <b-form-group
            class="text-right"
            >
            <b-button
                type="submit"
                variant="primary"
                @click="save"
                >
                Save
            </b-button>
        </b-form-group>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ]),
    },
    data() {
        return {
            form: {
                page: {
                    header: '',
                    'headerCollapse': '',
                    footer: '',
                    'footerCollapse': '',
                },
                modal: {
                    header: '',
                    'headerCollapse': '',
                    footer: '',
                    'footerCollapse': '',
                },
            },
            quillEdiorOptions: {
                theme: 'snow',
            },
        }
    },
    async mounted() {
        await this.fetch()
    },
    methods: {
        async fetch() {
            await this.$store
                .dispatch('setting/show')
                .then((response) => {
console.log(response.data.data)
                    this.$set(this, 'form', response.data.data)
                })
                .catch((error) => {
                })
        },
        async save() {
            await this.$store
            .dispatch('setting/save', { data: this.form, })
                .then((response) => {
console.log(response.data.data)
                    this.$set(this, 'form', response.data.data)
                    this.$store.dispatch('notification/push', { color: 'success', text: 'Saved', })
                })
                .catch((error) => {
                })
        },
    },
}
</script>

<style>
.ql-editor{
    min-height:200px;
}
</style>
